const getAuthHeader = () => {
  const accessToken = localStorage.getItem('accessDarwinToken');
  return accessToken ? { Authorization: accessToken } : '';
};

interface IToken {
  code: number;
  data: string;
  message: string;
}

const REACT_APP_DARWIN_URL = import.meta.env.VITE_DARWIN_URL;

export async function getToken(
  nonce: string,
  sig: string
): Promise<{ data: IToken }> {
  try {
    const response = await fetch(`${REACT_APP_DARWIN_URL}/auth/login`, {
      method: 'POST',
      headers: {
        ...getAuthHeader(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ nonce, sig }),
    });

    // if (!response.ok) {
    //   throw new Error('Request failed');
    // }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw new Error('An error occurred');
  }
}

export function isDummyLogin() {
  return import.meta.env.VITE_USE_DUMMY_LOGIN === 'true';
}

export async function getTokenByEmail(
  email: string
): Promise<{ data: IToken }> {
  try {
    const response = await fetch(`${REACT_APP_DARWIN_URL}/auth/login/dummy`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    if (!response.ok) {
      throw new Error('Login failed');
    }
    return await response.json();
  } catch (error) {
    console.error('getTokenByEmail error', error);
    throw error;
  }
}
